import { nameRegex } from "constants/regex";

export const personalDetailsInputMask = (value: string): string => value.replace(nameRegex, '');